import { useTranslation } from '@hooks/useTranslation';
import { Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import { useEffect } from 'react';
import { setWolfieKnowledge, setWolfieTemporaryProcesses } from '@redux/reducers/wolfie.reducer';
import ProcessesGraphQL from '@graphql/process.queries';
import { createOrUpdateProcessRequest } from '@models/process.model';
import { graphQlClient } from '@config/graphqlClient';
import { appendActionMessage } from '@redux/reducers/actionMessages.reducer';
import { SnackType } from '@models/common.model';

const WolfieDevPanel = () => {
  const { knowledge, temporaryProcesses, conversations } = useAppSelector((state: RootState) => state.wolfie);

  const localeSettings = useTranslation('settings');
  const localeCommon = useTranslation('common');
  const localeActionMessages = useTranslation('actionMessages');
  const dispatch = useAppDispatch();

  useEffect(() => {
    // dispatch(setWolfieKnowledge(knowledge || []));
    dispatch(setWolfieKnowledge(knowledge || []));
  }, [knowledge]);

  useEffect(() => {
    // dispatch(setWolfieTemporaryProcesses([]));
    dispatch(setWolfieTemporaryProcesses(temporaryProcesses || []));
  }, [temporaryProcesses]);

  const showErrorSnack = (e: any) => {
    dispatch(
      appendActionMessage({
        message: e?.response?.errors[0]?.message || localeCommon['requestError'],
        type: SnackType.ERROR,
      }),
    );
  };

  const handleProcessCreate = async (name: string, goal: string, serviceId: string) => {
    const query = ProcessesGraphQL.mutations.createProcess;
    const params = {
      process: {
        name,
        goal,
        serviceId,
      },
    };
    try {
      const data: createOrUpdateProcessRequest = await graphQlClient.request(query, params);
      if (data?.createProcess) {
        dispatch(setWolfieKnowledge(data?.createProcess?.aiMetadata?.knowledge || []));
        dispatch(setWolfieTemporaryProcesses(temporaryProcesses.filter((process) => process.name !== name) || []));
        dispatch(
          appendActionMessage({
            message: localeActionMessages['processCreatedSuccessfully'],
            type: SnackType.SUCCESS,
          }),
        );
      }
    } catch (e) {
      showErrorSnack(e);
    }
  };

  // debugger
  // console.log('conversations', conversations);
  // debugger

  return (
    <Box
      className="w-1/4 z-50 p-4 fixed right-0 top-0 bottom-0 overflow-auto bg-white"
      sx={{
        height: '100vh',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
      }}>
      <div className="text-xl font-bold mb-4">{localeSettings['wolfieDevPanel']}</div>

      <div className="mb-6">
        <h2 className="text-lg font-semibold mb-2">Conversations</h2>
        {conversations && conversations?.length > 0 ? (
          [...conversations]
            .sort((a, b) => new Date(b.lastUpdatedAt).getTime() - new Date(a.lastUpdatedAt).getTime())
            .map((item) => (
              <div
                key={item.conversationId}
                className={`flex flex-row p-2 rounded mb-2 ${item.status === 'current' ? 'bg-blue-100 border-l-4 border-blue-500' : 'bg-gray-50'}`}>
                <div className="flex flex-col">
                  {/* <span className={`font-medium text-sm ${item.status === 'current' ? 'text-blue-700' : 'text-gray-600'}`}>{item.conversationId}</span> */}
                  <span className={`text-sm ${item.status === 'current' ? 'font-semibold' : ''}`}>{item.title}</span>
                  {item.status === 'current' && (
                    <span className="text-xs text-blue-600 mt-1">Current conversation</span>
                  )}
                </div>
              </div>
            ))
        ) : (
          <div className="text-gray-600">No conversations found</div>
        )}
      </div>

      {/* <div className="mb-6">
        <h2 className="text-lg font-semibold mb-2">Knowledge</h2>
        {knowledge?.map((item) => (
          <div key={item.id} className="flex flex-row bg-gray-50 p-2 rounded mb-2">
            <div className="flex flex-col">
              <span className="font-medium text-sm text-gray-600">{item.id}</span>
              <span className="text-sm">{item.text}</span>
            </div>
          </div>
        ))}
      </div> */}

      {/* <div>
        <h2 className="text-lg font-semibold mb-2">Temporary Processes</h2>
        {temporaryProcesses?.map((item) => (
          <div key={item.name} className="flex flex-row bg-gray-50 p-2 rounded mb-2">
            <div className="flex flex-col flex-grow">
              <span className="font-bold text-sm">{item.name}</span>
              <span className="text-sm text-gray-600 opacity-75">Belongs in Area: <span className="font-semibold opacity-100">{item.areaName}</span></span>
              <span className="text-sm text-gray-600 opacity-75">Belongs in Service: <span className="font-semibold opacity-100">{item.serviceName}</span></span>
              <span className="text-sm text-gray-600">Goal: {item.goal}</span>
              <span className="text-sm font-bold">
                Status: <span className={item.complete ? 'text-green-600' : 'text-amber-600'}>
                  {item.complete ? 'Ready to Create' : 'In Progress'}
                </span>
              </span>
            </div>
            <div className="flex items-start">
              {/* Use wolfie icons */}
      {/* {item.complete ? (
                <div
                  className="cursor-pointer"
                  onClick={() => handleProcessCreate(item.name, item.goal, item.serviceId)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                </svg>
              )}
            </div>
          </div>
        ))}
      </div> */}
    </Box>
  );
};

export default WolfieDevPanel;
